import Vue from "vue";
import Router from "vue-router";
import CompanyHome from "@/views/CompanyHome.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    { path: "/", component: CompanyHome },
    {
      path: '/:asin',
      name: 'CompanyHomeAsin',
      component: () => import('../views/CompanyHomeAsin.vue')
    }
  ],
});
